import { uploadExternalFile } from '@homeservices/api-kit/proreferral/files/v2';
import { format, differenceInDays, max } from 'date-fns';

export function getDeliveryDate (orders) {
  return max(orders.map((order) => {
    return new Date(order.shipping.estimated_delivery_date_to);
  }));
}

export function getUrgency (deliveryDate, originDate) {
  const daysUntilDelivery = differenceInDays(deliveryDate, originDate);

  if (daysUntilDelivery <= 7) {
    return 1;
  }

  if (daysUntilDelivery <= 30) {
    return 2;
  }

  return 3;
}

export function getNotes (orders, deliveryDate) {
  return [
    'Order details:\n',
    ...orders.map(order => `Qty ${order.quantity} - ${order.name}`),
    `\nThe scheduled delivery will be on ${format(new Date(deliveryDate), 'MM/dd/yyyy')}. Please contact me to set up an appointment`,
  ].join('\n');
}

export async function getImages (orders) {
  const images = [];

  await Promise.all(orders.map(async (order) => {
    const { data } = await uploadExternalFile({ external_file: order.image_url });
    images.push(data);
  }));

  return images;
}
